// Hinweis "Als App installieren?" auf Android und iOS.
//
// Android (Chrome, Edge, Samsung Internet) meldet per `beforeinstallprompt`,
// dass sich die Seite installieren lässt. Das Ereignis kommt früh, oft bevor
// React steht, deshalb fängt dieses Modul es schon beim Laden ab (Import in
// App.js). iOS kennt kein solches Ereignis: Dort bleibt nur die Anleitung
// "Teilen → Zum Home-Bildschirm".

export const INSTALL_SPAETER_KEY = 'kcInstallHinweisSpaeter';
export const INSTALL_PAUSE_TAGE = 14;
export const INSTALL_EREIGNIS = 'installHinweisBereit';

let gemerktesEreignis = null;

export function istIos({ userAgent = '', plattform = '', maxTouchPoints = 0 } = {}) {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return true;
  // iPadOS meldet sich als Mac, hat aber einen Touchscreen.
  return /Mac/i.test(plattform) && maxTouchPoints > 1;
}

export function istAndroid({ userAgent = '' } = {}) {
  return /Android/i.test(userAgent);
}

export function istInstalliert({ standaloneMedia = false, navigatorStandalone = false } = {}) {
  return !!(standaloneMedia || navigatorStandalone);
}

export function pausiertBis(gespeichert, jetzt = Date.now()) {
  const bis = Number(gespeichert);
  return Number.isFinite(bis) && bis > jetzt;
}

// Welcher Hinweis gezeigt wird: 'android' (mit Knopf), 'ios' (Anleitung) oder
// null. Auf dem Desktop nie, auch wenn Chrome dort installieren könnte.
export function hinweisArt({ geraet, installiert, pausiert, androidEreignisDa }) {
  if (installiert || pausiert) return null;
  if (geraet.ios) return 'ios';
  if (geraet.android && androidEreignisDa) return 'android';
  return null;
}

export function geraetsDaten() {
  try {
    const nav = window.navigator || {};
    const daten = { userAgent: nav.userAgent || '', plattform: nav.platform || '', maxTouchPoints: nav.maxTouchPoints || 0 };
    return { ios: istIos(daten), android: istAndroid(daten) };
  } catch (_) {
    return { ios: false, android: false };
  }
}

export function laeuftInstalliert() {
  try {
    const standaloneMedia = !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
    return istInstalliert({ standaloneMedia, navigatorStandalone: window.navigator && window.navigator.standalone === true });
  } catch (_) {
    return false;
  }
}

export function liesPause() {
  try { return pausiertBis(window.localStorage.getItem(INSTALL_SPAETER_KEY)); } catch (_) { return false; }
}

export function setzePause(tage = INSTALL_PAUSE_TAGE) {
  try { window.localStorage.setItem(INSTALL_SPAETER_KEY, String(Date.now() + tage * 24 * 60 * 60 * 1000)); } catch (_) {
    // Ohne localStorage erscheint der Hinweis beim nächsten Laden wieder.
  }
}

export function androidEreignis() {
  return gemerktesEreignis;
}

export function vergissAndroidEreignis() {
  gemerktesEreignis = null;
}

if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Kein eigenes Mini-Banner des Browsers, wir fragen selbst.
    e.preventDefault();
    gemerktesEreignis = e;
    try { window.dispatchEvent(new CustomEvent(INSTALL_EREIGNIS)); } catch (_) {
      // Die Komponente prüft beim Einhängen ohnehin androidEreignis().
    }
  });
  window.addEventListener('appinstalled', () => {
    gemerktesEreignis = null;
    try { window.dispatchEvent(new CustomEvent(INSTALL_EREIGNIS)); } catch (_) {
      // Siehe oben.
    }
  });
}
